var _path, _path2, _path3, _path4, _path5, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProDisk = function SvgProDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.813 28.37 65.1 3.14A47.876 47.876 0 0 0 48 0C21.49 0 0 21.49 0 48a47.827 47.827 0 0 0 4.186 19.63l26.713 25.231c3.893 1.02 10.712.965 14.925.965 26.51 0 48-21.49 48-48.001 0-5.129-.522-12.82-2.011-17.454zM47.999 59.088c-1.391 0-2.722-.258-3.949-.726h-6.168v-5.828a11.044 11.044 0 0 1-.97-4.533c0-6.123 4.964-11.087 11.087-11.087 1.392 0 2.722.26 3.95.727h6.168v5.828c.62 1.384.969 2.917.969 4.533 0 6.123-4.963 11.087-11.087 11.087z",
    fill: "url(#pro-disk_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.714 29.307a47.963 47.963 0 0 1 2.297 14.701c0 26.51-21.49 48-48 48-4.213 0-8.3-.544-12.193-1.563h-.92v2.413A47.875 47.875 0 0 0 48 95.998c26.51 0 48-21.491 48-48.001a47.826 47.826 0 0 0-4.186-19.63h-2.099v.94z",
    fill: "#FAD846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.044 58.367a11.12 11.12 0 0 1-6.168-5.828L4.18 67.636a48.042 48.042 0 0 0 7.94 12.257c6.203 5.843 13.963 10.561 19.693 10.561l12.231-32.087zm7.901-20.726a11.12 11.12 0 0 1 6.169 5.828L89.71 29.312c0-4.656-3.537-10.4-9.829-17.185A47.975 47.975 0 0 0 65.097 3.14l-13.152 34.5z",
    fill: "#FAD846"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.81 28.37a48.13 48.13 0 0 0-11.927-16.245 47.934 47.934 0 0 1 9.829 17.186l2.099-.94z",
    fill: "#F3BB33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 79.89a48.078 48.078 0 0 0 18.773 12.975l.92-2.413A47.883 47.883 0 0 1 12.125 79.89z",
    fill: "#F2A642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.101,
    cy: 49.101,
    fill: "#29292C",
    r: 13.749
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro-disk_svg__a",
    x1: 46.912,
    y1: 0,
    x2: 46.912,
    y2: 93.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#F3D223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F2994A"
  })))));
};
export default SvgProDisk;